export const artikel = [
  {
    id: 'aufstockung-holz-suedtirol',
    slug: 'aufstockung-holz-suedtirol',
    titel: 'Aufstockung in Holz: Vorteile und Ablauf in Südtirol',
    titel_it: 'Sopraelevazione in legno: vantaggi e procedura in Alto Adige',
    kategorie: 'Aufstockung',
    datum: '2025-11-15',
    lesezeit: '6 min',
    vorschau: 'Warum eine Aufstockung in Holz die intelligenteste Lösung für mehr Raum ist – schneller, leichter und präziser als jede Alternative.',
    vorschau_it: 'Perché una sopraelevazione in legno è la soluzione più intelligente per più spazio – più veloce, più leggera e più precisa di qualsiasi alternativa.',
    bild: 'https://images.unsplash.com/photo-1542020407333-1bac30628eaf?w=800&q=80',
    inhalt: `
## Warum Aufstockung statt Neubau?

Wer mehr Wohnfläche braucht, denkt oft zuerst an Neubau oder Umzug. Dabei liegt eine oft übersehene Möglichkeit direkt über dem Kopf: die Aufstockung des bestehenden Gebäudes.

Eine Aufstockung ist wirtschaftlich, verursacht weniger CO₂ als ein Neubau und schafft in kurzer Zeit neuen, hochwertigen Raum. Besonders in städtischen Lagen wie Meran, wo Bauland knapp und teuer ist, ist die Aufstockung oft die einzige realistische Option zur Flächenerweiterung.

## Warum gerade Holz?

**Geringes Eigengewicht**: Holzkonstruktionen sind deutlich leichter als Beton oder Mauerwerk. Das bestehende Fundament und Tragwerk werden in den meisten Fällen nicht zusätzlich belastet – oder nur minimal verstärkt.

**Vorfertigung**: Alle Elemente werden im Werk präzise gefertigt. Die Montage auf der Baustelle dauert oft nur wenige Tage. Weniger Lärm, weniger Staub, weniger Einschränkungen.

**Energieeffizienz**: Holz ist ein natürlicher Wärmedämmstoff. In Kombination mit moderner Dämmtechnik erreichen Aufstockungen in Holz problemlos Klimahaus-Standard.

## Der Ablauf bei Holzbuddy

1. **Erstgespräch & Bestandsanalyse**: Wir beurteilen Ihr Gebäude und prüfen die Machbarkeit.
2. **Konzept & 3D-Visualisierung**: Klare Darstellung der Möglichkeiten.
3. **Einreichplanung**: Wir begleiten Sie durch den Genehmigungsprozess.
4. **Vorfertigung**: Elemente werden in unserer Werkstatt produziert.
5. **Montage**: Typisch 3–7 Tage auf der Baustelle.
6. **Übergabe**: Vollständig dokumentiert und abgeschlossen.

## Was kostet eine Aufstockung?

Das hängt von vielen Faktoren ab: Grundriss, Ausstattungsniveau, Aufwand am Bestand. Als grobe Orientierung: Aufstockungen in Holz starten bei ca. 1.200 €/m² Nutzfläche. Ein unverbindliches Richtangebot erstellen wir gerne nach Besichtigung.

## Fazit

Wer mehr Fläche braucht und klug investieren möchte, sollte die Aufstockung in Holz ernsthaft in Betracht ziehen. Sie ist schneller, leichter und oft günstiger als ein Neubau.
    `
  },
  {
    id: 'dachstuhl-sanieren-oder-neu',
    slug: 'dachstuhl-sanieren-oder-neu',
    titel: 'Dachstuhl: Sanieren oder komplett neu bauen?',
    titel_it: 'Struttura del tetto: risanare o costruire ex novo?',
    kategorie: 'Dachstuhl',
    datum: '2025-10-08',
    lesezeit: '5 min',
    vorschau: 'Wann lohnt sich die Sanierung des bestehenden Dachstuhls – und wann ist ein Neubau die bessere Entscheidung?',
    vorschau_it: 'Quando conviene risanare la struttura del tetto esistente – e quando una nuova costruzione è la scelta migliore?',
    bild: 'https://images.unsplash.com/photo-1761380693275-20e7cb7c95d5?w=800&q=80',
    inhalt: `
## Die Frage, die viele Hausbesitzer beschäftigt

Ein alter Dachstuhl ist oft das erste, was beim Hauskauf oder bei einer Sanierung unter die Lupe kommt. Und oft steht man vor der Frage: Retten oder ersetzen?

Die ehrliche Antwort: Es kommt darauf an.

## Wann ist Sanierung sinnvoll?

**Der Grundcharakter der Konstruktion noch intakt ist**: Tragende Teile sind gesund, die Geometrie stimmt.

**Nur einzelne Bereiche betroffen sind**: Schäden durch Feuchtigkeit oder Insekten sind lokal begrenzt.

**Ein historisches Gebäude vorliegt**: Bei Denkmalschutz oder besonderem Bestandswert.

**Budget begrenzt ist**: Gezielte Eingriffe sind oft günstiger als ein vollständiger Neubau.

## Wann ist ein Neubau besser?

Ein neuer Dachstuhl ist die richtige Wahl, wenn:

**Der Bestand zu stark geschädigt ist**: Pilzbefall, umfangreiche Fäulnis, statische Mängel.

**Eine Aufstockung geplant ist**: Ein neuer Dachstuhl erlaubt von Beginn an optimale Raumgestaltung.

**Zeitdruck besteht**: Ein kompletter Neubau in Vorfertigung ist manchmal schneller als eine aufwendige Sanierung.

## Unsere Empfehlung

Lassen Sie den Zustand professionell beurteilen. Wir kommen gerne vor Ort und geben Ihnen eine ehrliche Einschätzung – ohne Verpflichtung.

## Was sagt die Praxis?

In über 60% der von uns begutachteten Fälle ist eine gezielte Teilsanierung die wirtschaftlichste und nachhaltigste Lösung. Aber ohne genaue Bestandsaufnahme lässt sich das nicht pauschal sagen.
    `
  },
  {
    id: 'holzfassade-worauf-kommt-es-an',
    slug: 'holzfassade-worauf-kommt-es-an',
    titel: 'Holzfassade: Worauf kommt es wirklich an?',
    titel_it: 'Facciata in legno: cosa conta davvero?',
    kategorie: 'Holzfassaden',
    datum: '2025-09-22',
    lesezeit: '7 min',
    vorschau: 'Eine Holzfassade hält Jahrzehnte – wenn sie richtig geplant und ausgeführt ist. Die entscheidenden Faktoren im Überblick.',
    vorschau_it: 'Una facciata in legno dura decenni – se pianificata e realizzata correttamente. I fattori determinanti in sintesi.',
    bild: 'https://images.unsplash.com/photo-1605018075968-b014b8d2e487?w=800&q=80',
    inhalt: `
## Eine Fassade, die altert

Holzfassaden altern. Das ist keine Schwäche, das ist ihr Charakter. Unbehandeltes Lärchenholz wird über die Jahre silbergrau – und sieht dabei oft sogar besser aus als am ersten Tag.

Aber: Das setzt voraus, dass die Fassade richtig konstruiert und montiert ist. Eine schlechte Fassade fault. Eine gute hält 40 Jahre und mehr.

## Die wichtigsten Faktoren

### 1. Die Unterkonstruktion

Die Unterkonstruktion entscheidet über alles. Sie muss sicherstellen, dass Hinterlüftung gewährleistet ist, Anschlüsse dauerhaft dicht sind und die Befestigungen korrosionsfest sind.

### 2. Die Holzart

**Lärche**: Der Klassiker. Hart, harzreich, dauerhaft. Ideal für Südtirol.

**Fichte**: Weicher, aber bei richtiger Konstruktion sehr gut.

**Thermoholz**: Industriell vergütet, besonders maßhaltig und resistent.

### 3. Die Profilwahl

Ob glatt, profiliert, horizontal oder vertikal – das ist nicht nur Optik. Profile beeinflussen auch die Wasserableitung.

### 4. Pflege – oder keine Pflege?

Unbehandelte Fassaden: Einfach in Ruhe lassen. Sie vergrauern, das ist gewollt.

Behandelte Fassaden: Alle 8–15 Jahre erneuern. Qualität des Anstrichs und Witterungsbelastung bestimmen das Intervall.

## Fazit

Eine Holzfassade ist kein Wartungsproblem – wenn sie richtig geplant ist. Der häufigste Fehler: schlechte Hinterlüftung und falsche Anschlüsse. Wir planen das von Anfang an richtig.
    `
  },
  {
    id: 'holzbau-bestand-suedtirol',
    slug: 'holzbau-bestand-suedtirol',
    titel: 'Holzbau im Bestand: Sinnvoll und zukunftsfähig',
    titel_it: 'Costruzione in legno nel patrimonio edilizio: sensata e duratura',
    kategorie: 'Sanierung',
    datum: '2025-08-14',
    lesezeit: '5 min',
    vorschau: 'Warum der Holzbau im Bestand in Südtirol besonders sinnvoll ist – und wie er gelingt.',
    vorschau_it: 'Perché la costruzione in legno nel patrimonio edilizio è particolarmente sensata in Alto Adige – e come si realizza con successo.',
    bild: 'https://hafner-ec.com/wp-content/uploads/2024/12/Baufirma-Hafner-Jonas-17-DSCF0911-400x300.jpg',
    inhalt: `
## Bestand ist kein Rückschritt

Der Blick in die Zukunft des Bauens geht zunehmend zurück: Bestand erhalten, sanieren, aufwerten. Nicht alles abreißen und neu bauen. Das ist ökologisch klüger, wirtschaftlich oft besser und kulturell wertvoll.

Holz spielt dabei eine besondere Rolle. Es ist das einzige Baumaterial, das sich so gut mit Bestandskonstruktionen verbinden lässt.

## Südtirol: Besondere Ausgangslage

In Südtirol gibt es viele Gebäude, die sanierungsbedürftig sind, aber sanierungswürdig. Alte Bauernhäuser, historische Stadtwohnungen, Hotels der 70er-Jahre. In vielen Fällen ist Holzbau die eleganteste Lösung.

## Typische Einsatzbereiche

- Dachsanierungen mit neuen Holzkonstruktionen
- Aufstockungen auf Bestandsgebäuden
- Fassadensanierungen mit Holzverkleidungen
- Balkonanbau in Holz

## Fazit

Holzbau im Bestand ist kein Kompromiss. Er ist oft die präziseste, schnellste und intelligenteste Lösung.
    `
  },
  {
    id: 'hotelumbau-zwischensaison',
    slug: 'hotelumbau-zwischensaison',
    titel: 'Hotelumbau in der Zwischensaison – so geht es richtig',
    titel_it: 'Ristrutturazione alberghiera nella bassa stagione – come si fa correttamente',
    kategorie: 'Hotelbau',
    datum: '2025-07-10',
    lesezeit: '6 min',
    vorschau: 'Hotels in Südtirol haben nur wenige Wochen für Umbaumaßnahmen. Wie Holzbau dabei den entscheidenden Vorteil bringt.',
    vorschau_it: 'Gli hotel in Alto Adige hanno solo poche settimane per lavori di ristrutturazione. Come la costruzione in legno offre il vantaggio decisivo.',
    bild: 'https://hafner-ec.com/wp-content/uploads/2025/04/Kohlbrenner-99-2500-400x300.jpg',
    inhalt: `
## Das Problem: Zu wenig Zeit, zu hohe Erwartungen

Wer ein Hotel in Südtirol umbaut, hat in der Regel nur die Zwischensaison: November bis März oder Juli/August. Das sind 6–10 Wochen. In dieser Zeit soll ein komplettes Stockwerk aufgestockt, eine neue Fassade montiert oder ein Spa-Bereich erweitert werden.

Mit klassischem Hochbau kaum machbar. Mit Holzbau – durchaus.

## Warum Holz im Hotelbau so gut funktioniert

**Vorfertigung eliminiert Bauzeit**: Während der Saison wird geplant und im Werk gefertigt. In der Zwischensaison wird montiert – typisch in 1–3 Wochen statt Monaten.

**Geringes Gewicht**: Aufstockungen in Holz belasten die bestehende Tragstruktur minimal. Oft keine aufwändige Verstärkung nötig.

**Saubere Baustelle**: Kein Beton, keine Mischmaschinen, wenig Staub. Das Hotel kann schnell wieder gereinigt und bezogen werden.

**Atmosphäre**: Holz schafft sofort Wärme und Qualität im Innenraum. Gäste spüren den Unterschied.

## Typische Projekte für Hotels

- Aufstockung um 1–2 Zimmergeschosse
- Anbau Spa- und Wellnessbereiche
- Außenterrassen und Balkone
- Chalets und Lodges als Erweiterung
- Rezeptionen und Lobbys in Holz

## Unser Angebot an Hoteliers

Wir kennen die Logik der Hotellerie. Wir planen mit Ihnen in der Saison, fertigen vor und montieren in Ihrer Zwischensaison. Mit einem klaren Terminversprechen.
    `
  },
  {
    id: 'planung-vorfertigung-bauzeit',
    slug: 'planung-vorfertigung-bauzeit',
    titel: 'Planung, Vorfertigung und Bauzeit – was wirklich entscheidet',
    titel_it: 'Pianificazione, prefabbricazione e tempi di costruzione – cosa conta davvero',
    kategorie: 'Planung',
    datum: '2025-06-18',
    lesezeit: '5 min',
    vorschau: 'Warum die Bauzeit bei einem Holzbauprojekt fast ausschließlich durch die Qualität der Planung bestimmt wird.',
    vorschau_it: 'Perché il tempo di costruzione di un progetto in legno è determinato quasi esclusivamente dalla qualità della pianificazione.',
    bild: 'https://images.unsplash.com/photo-1760067537293-6b30141d6a52?w=800&q=80',
    inhalt: `
## Die häufigste Frage: Wie lange dauert das?

Jeder Bauherr stellt sie. Und die ehrliche Antwort ist: Es kommt fast ausschließlich auf die Planung an.

Ein schlecht geplantes Projekt dauert immer zu lang. Ein gut geplantes Projekt, mit hoher Vorfertigung, kann in erstaunlich kurzer Zeit abgeschlossen werden.

## Was Vorfertigung wirklich bedeutet

Vorfertigung bedeutet nicht: Ein bisschen im Werk sägen und dann auf der Baustelle improvisieren.

Vorfertigung bedeutet: Alle Elemente sind fertig, wenn die Montage beginnt. Kein Warten, kein Nachliefern, kein Anpassen.

Das funktioniert nur, wenn die Planung lückenlos ist. Jedes Maß stimmt. Jeder Anschluss ist durchdacht. Jede Schnittstelle ist dokumentiert.

## Der Holzbuddy-Prozess

1. **Vollständige Planung** – bevor etwas bestellt oder gefertigt wird
2. **3D-Modell als Produktionsgrundlage** – Millimetergenauigkeit
3. **Fertigung im Werk** – unter kontrollierten Bedingungen
4. **Montage** – schnell, sauber, ohne Überraschungen

## Was das für Sie bedeutet

Weniger Baustellenlärm. Weniger Schmutz. Weniger Stress. Und ein verlässliches Datum, an dem Ihr Projekt fertig ist.

Das ist kein Versprechen – das ist das Ergebnis guter Planung.
    `
  },
  {
    id: 'holzbau-energieeffizienz-suedtirol',
    slug: 'holzbau-energieeffizienz-suedtirol',
    titel: 'Holzbau und Energieeffizienz in Südtirol',
    titel_it: 'Costruzione in legno ed efficienza energetica in Alto Adige',
    kategorie: 'Planung',
    datum: '2025-05-20',
    lesezeit: '5 min',
    vorschau: 'Wie Holzbau und KlimaHaus-Standard zusammenpassen – und warum Holz thermisch besser ist als Beton.',
    vorschau_it: 'Come la costruzione in legno e lo standard KlimaHaus si abbinano – e perché il legno è termicamente superiore al calcestruzzo.',
    bild: 'https://images.unsplash.com/photo-1748007702945-cca7b75d96ca?w=800&q=80',
    inhalt: `
## Südtirol und das KlimaHaus-Programm

Kaum ein Bundesland in Europa hat so konsequent auf Energieeffizienz gesetzt wie Südtirol. Das KlimaHaus-Programm ist weltweit bekannt und setzt Standards, die weit über gesetzliche Anforderungen hinausgehen.

Und Holzbau passt dazu perfekt.

## Warum Holz thermisch überlegen ist

Holz hat eine sehr geringe Wärmeleitfähigkeit. Es leitet Wärme schlecht – und das ist beim Bauen ein Vorteil. Im Gegensatz zu Beton oder Stahl gibt es keine Wärmebrücken durch das Material selbst.

In einer gut konzipierten Holzkonstruktion sind thermisch bedingte Schwachstellen weitgehend vermieden.

## KlimaHaus A und Holzbau

KlimaHaus A und sogar A+ sind mit Holzrahmenbau erreichbar – ohne exotische Materialien oder komplizierte Konstruktionen. Die Kombination aus gutem Dämmstoff, sorgfältiger Luftdichtheitsebene und gut geplanten Anschlüssen reicht.

## Was das für Baukosten bedeutet

Ein gut gedämmtes Holzhaus kostet in der Errichtung etwas mehr als ein Standardgebäude. Aber die Heizkosten sind drastisch niedriger. Über die Lebensdauer des Gebäudes rechnet es sich fast immer.

## Fazit

Wer in Südtirol baut und energieeffizient bauen will, ist mit Holz gut beraten. Wir planen KlimaHaus-Standard als Normalfall – nicht als Ausnahme.
    `
  },
  {
    id: 'genehmigung-holzbau-suedtirol',
    slug: 'genehmigung-holzbau-suedtirol',
    titel: 'Baugenehmigung in Südtirol: Was Bauherren wirklich wissen müssen',
    titel_it: 'Concessione edilizia in Alto Adige: cosa devono sapere i committenti',
    kategorie: 'Planung',
    datum: '2026-01-20',
    lesezeit: '7 min',
    vorschau: 'Der Genehmigungsprozess in Südtirol ist komplex – aber mit der richtigen Vorbereitung beherrschbar. Ein Überblick für Bauherren.',
    vorschau_it: 'Il processo di concessione edilizia in Alto Adige è complesso – ma con la giusta preparazione è gestibile. Una panoramica per i committenti.',
    bild: 'https://images.unsplash.com/photo-1554469384-e58fac16e23a?w=800&q=80',
    inhalt: `
## Das Genehmigungssystem in Südtirol

Südtirol hat als autonome Provinz eigene Baurechtsbestimmungen, die sich von nationalen italienischen Vorschriften unterscheiden. Das macht die Planung manchmal komplex – aber auch verlässlich, wenn man die Spielregeln kennt.

## Die wichtigsten Genehmigungsarten

### 1. SCIA – Segnalazione Certificata di Inizio Attività
Für kleinere Bauvorhaben, Sanierungen und bestimmte Instandhaltungsarbeiten. Die SCIA muss eingereicht werden, bevor die Arbeiten beginnen, bedarf aber keiner expliziten Genehmigung – sie gilt nach Einreichung.

### 2. Konzession (Baukonzession)
Für Neubauten, Aufstockungen und wesentliche Umgestaltungen ist eine vollständige Baukonzession erforderlich. Diese wird vom Gemeindeamt geprüft und erteilt.

### 3. Landschaftsschutz
In Südtirol liegen viele Bauparzellen in Schutzzonen. Hier gelten zusätzliche Auflagen – besonders für Fassaden, Materialwahl und Dachgestaltung.

## Was bedeutet das für Holzbauprojekte?

Holzbau wird in Südtirol grundsätzlich wohlwollend bewertet – das Material passt zur Baukultur der Region. Dennoch gibt es Punkte, auf die man achten muss:

- **Energieausweis (KlimaHaus)**: Bei Neubauten und wesentlichen Sanierungen ist ein KlimaHaus-Zertifikat Pflicht.
- **Statische Berechnung**: Bei Aufstockungen muss das bestehende Tragwerk geprüft und dokumentiert sein.
- **Brandschutz**: Bei mehrgeschossigen Bauten sind Nachweise zum Brandschutz erforderlich.

## Wie lange dauert das Genehmigungsverfahren?

Eine SCIA: Sofortiger Start möglich nach Einreichung.

Eine Baukonzession: In Südtirol typisch 60–120 Tage – bei vollständigen Unterlagen. Fehlende Dokumente verlängern das Verfahren erheblich.

## Unsere Empfehlung

Starten Sie die Planungsphase frühzeitig. Wir arbeiten mit erfahrenen lokalen Planungsbüros zusammen, die den Genehmigungsprozess kennen und beschleunigen können. Kontaktieren Sie uns – wir stellen gerne den richtigen Kontakt her.
    `
  },
  {
    id: 'holzhaus-vs-massivbau',
    slug: 'holzhaus-vs-massivbau',
    titel: 'Holzhaus oder Massivbau? Ein ehrlicher Vergleich für Südtirol',
    titel_it: 'Casa in legno o costruzione massiva? Un confronto onesto per l\'Alto Adige',
    kategorie: 'Holzhaus',
    datum: '2026-01-08',
    lesezeit: '8 min',
    vorschau: 'Holz oder Stein? Diese Frage stellen sich viele Bauherren in Südtirol. Wir liefern einen ehrlichen, sachlichen Vergleich – ohne Werbebotschaften.',
    vorschau_it: 'Legno o pietra? Questa domanda se la pongono molti committenti in Alto Adige. Forniamo un confronto onesto e obiettivo – senza messaggi pubblicitari.',
    bild: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
    inhalt: `
## Die Frage, die wirklich zählt

Kein Bausystem ist universell besser. Es kommt auf die Rahmenbedingungen an: Grundstück, Budget, Nutzung, Zeitplan und persönliche Präferenz. Was wir Ihnen bieten: eine ehrliche Abwägung.

## Bauzeit

**Holzhaus**: Durch Vorfertigung im Werk ist die Rohbauphase erheblich kürzer. Ein Holzrahmenhaus kann in 2–4 Wochen montiert werden. Das gesamte Projekt (mit Planung und Genehmigung) dauert 8–14 Monate.

**Massivbau**: Der Rohbau dauert 4–6 Monate. Trocknungszeiten für Beton und Estrich verlängern das Projekt. Gesamtdauer: 14–24 Monate.

**Vorteil**: Holzbau

## Energieeffizienz

**Holzhaus**: Holz hat eine sehr geringe Wärmeleitfähigkeit. Wärmebrücken durch das Konstruktionsmaterial sind minimal. Klimahaus A und A+ sind problemlos erreichbar.

**Massivbau**: Hohe Masse speichert Wärme gut (Vorteil im Sommer). Aber: Wärmebrücken durch Betondecken und -wände müssen durch Dämmung behoben werden.

**Fazit**: Beide Systeme können hohe Energieeffizienz erreichen – beim Holzbau ist es konstruktiv einfacher.

## CO₂-Bilanz

**Holzhaus**: Holz speichert CO₂. Ein Holzhaus ist eine CO₂-Senke – es bindet mehr Kohlendioxid als bei der Herstellung ausgestoßen wird.

**Massivbau**: Zement- und Betonproduktion ist einer der größten CO₂-Emittenten weltweit.

**Vorteil**: Holzbau – erheblich.

## Kosten

Beide Systeme können bei gleicher Ausstattung und Qualität ähnliche Kosten erzeugen. Holzbau ist nicht automatisch teurer. Die Unterschiede liegen oft in der Ausstattung, nicht im Bausystem.

Was Holzbau spart: kürzere Bauzeit (weniger Finanzierungskosten), weniger Lageraufwand, schnellere Bezugsfertigkeit.

## Raumgefühl

**Holzhaus**: Natürliche Materialien schaffen ein behagliches Raumklima. Die Konstruktion ist schlank – mehr Nutzfläche bei gleicher Außendimension.

**Massivbau**: Schwere, massige Wände. Manche Bauherren schätzen das Gefühl von Solidität und Dauerhaftigkeit.

## Fazit

Für Südtirol – mit seiner Holzbautradition, seinen Klimahausanforderungen und dem Wunsch nach kurzen Bauzeiten – ist das Holzhaus in den meisten Fällen die bessere Wahl. Aber: Ohne Beratung sollten Sie keine Entscheidung treffen.
    `
  },
  {
    id: 'balkon-terrasse-holz',
    slug: 'balkon-terrasse-holz',
    titel: 'Holzbalkon und Holzterrasse in Südtirol: Planung, Holzarten, Pflege',
    titel_it: 'Balcone e terrazza in legno in Alto Adige: pianificazione, essenze e manutenzione',
    kategorie: 'Terrassen',
    datum: '2025-12-18',
    lesezeit: '6 min',
    vorschau: 'Ein Holzbalkon oder eine Holzterrasse wertet jede Immobilie auf. Was Sie über Holzarten, Konstruktion und Pflege wissen sollten.',
    vorschau_it: 'Un balcone o una terrazza in legno valorizza qualsiasi immobile. Cosa sapere su essenze, costruzione e manutenzione.',
    bild: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    inhalt: `
## Warum Holz für Balkone und Terrassen?

Holz ist das natürlichste und wärmste Material für Außenbereiche. Es hat eine einzigartige Haptik, altert schön und lässt sich perfekt an jede Architektur anpassen. In Südtirol ist Holz das traditionelle Material für Balkone – und das aus gutem Grund.

## Die Holzarten im Vergleich

### Lärche – Der Klassiker
Die Lärche ist das Standardmaterial für Balkone und Terrassen in Südtirol. Sie ist hart, harzreich und resistent gegen Feuchtigkeit. Unbehandelt vergraut sie zu einem silbrigen Grauton – ein bewusster ästhetischer Entscheid.

### Bangkirai / Ipé – Tropische Hartholzarten
Sehr dicht und dauerhaft. Geeignet für stark beanspruchte Terrassen. Aber: Der Import aus Tropenholz widerspricht dem Nachhaltigkeitsgedanken.

### Thermoholz
Heimische Hölzer, die durch Hitzebehandlung dauerhafter werden. Maßhaltig, resistent, dimensionsstabil. Eine gute Alternative für anspruchsvolle Standorte.

### Laubhölzer (Eiche, Robinie)
Robinie ist eines der härtesten und dauerhaftesten einheimischen Holzarten. Sehr lange Lebensdauer, auch unbehandelt.

## Konstruktive Details, die entscheiden

**Gefälle**: Jede Terrassenfläche muss ein Mindestgefälle von 2% haben, damit Wasser abläuft. Stehendes Wasser ist der Feind jeder Holzterrasse.

**Belüftung**: Die Unterkonstruktion muss belüftet sein. Keine direkte Auflage auf feuchtem Beton.

**Anschlüsse**: Wandanschlüsse müssen gedichtet und mit Abstand geplant sein. Holz muss sich bewegen können.

**Befestigung**: Sichtbare Schrauben sind veraltet. Moderne Befestigungssysteme sind verdeckt montiert – das Ergebnis ist eine glatte, professionelle Oberfläche.

## Pflege und Lebensdauer

Unbehandeltes Lärchenholz: Einfach liegen lassen. Es vergraut, das ist gewollt. Kein Ölen nötig.

Behandeltes Holz: Alle 2–5 Jahre pflegen, abhängig von Witterungsbelastung und Besonnung.

Lebensdauer bei richtiger Konstruktion: 20–40 Jahre.

## Was kostet eine Holzterrasse?

Einfache Lärchenholzterrasse: ab ca. 250 €/m² (Lieferung und Montage).

Mit Beleuchtung, Geländer und besonderen Verbindungen: 400–800 €/m².

Wir erstellen Ihnen gerne ein Angebot nach Aufmaß.
    `
  },
  {
    id: 'zimmerei-architekt-zusammenarbeit',
    slug: 'zimmerei-architekt-zusammenarbeit',
    titel: 'Warum die Zimmerei früh ins Bauprojekt eingebunden werden sollte',
    titel_it: 'Perché la falegnameria dovrebbe essere coinvolta presto nel progetto edilizio',
    kategorie: 'Planung',
    datum: '2025-12-05',
    lesezeit: '5 min',
    vorschau: 'Viele Planungsfehler entstehen, weil die Zimmerei erst nach der Architektur eingebunden wird. Wie die frühe Zusammenarbeit Zeit und Geld spart.',
    vorschau_it: 'Molti errori di progettazione nascono dal coinvolgimento tardivo della falegnameria. Come la collaborazione precoce fa risparmiare tempo e denaro.',
    bild: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80',
    inhalt: `
## Das klassische Problem

Der Architekt plant. Der Planer rechnet. Und die Zimmerei wird beauftragt, das Geplante umzusetzen – oft zu einem Zeitpunkt, an dem Änderungen teuer oder gar nicht mehr möglich sind.

Das Resultat: Konstruktive Konflikte, unerwartete Kosten, Bauverzögerungen. Und manchmal ein Ergebnis, das funktioniert, aber nicht optimal ist.

## Was passiert, wenn die Zimmerei früh dabei ist

**Konstruktive Machbarkeit von Anfang an**: Wir können in frühen Planungsphasen sagen, was wie umsetzbar ist – und was günstiger gelöst werden kann.

**Vorfertigung optimal planen**: Wenn wir die Planungsgrundlage selbst mitentwickeln, können wir die Vorfertigung maximieren. Das reduziert die Baustellenzeit und verbessert die Qualität.

**Materialplanung**: Frühe Einbindung ermöglicht optimale Holzart- und Dimensionswahl – auch unter Budget- und Nachhaltigkeitsgesichtspunkten.

**Kostensicherheit**: Wer früh eingebunden wird, kann früh kalkulieren. Das gibt Bauherren und Architekten Kostensicherheit.

## Das ideale Workflow-Modell

1. **Vorentwurf**: Architect konzipiert, Zimmerei gibt konstruktive Einschätzung
2. **Entwurf**: Gemeinsame Detaillierung der Holzkonstruktionen
3. **Einreichplanung**: Zimmerei liefert Konstruktionsangaben für die Statik
4. **Ausführungsplanung**: Zimmerei übernimmt 3D-Modellierung für CNC-Fertigung
5. **Vorfertigung & Montage**: Reibungsloser Prozess, keine Überraschungen

## Unser Ansatz

Wir sind gerne früh dabei. Nicht um Architekten zu ersetzen – sondern um das Beste aus der Zusammenarbeit herauszuholen. Sprechen Sie uns an, auch wenn das Projekt noch in einer frühen Phase ist.
    `
  },
  {
    id: 'nachhaltiger-holzbau-klimabilanz',
    slug: 'nachhaltiger-holzbau-klimabilanz',
    titel: 'Nachhaltiger Holzbau in Südtirol: CO₂, Kreislauf und Zukunft',
    titel_it: 'Costruzione in legno sostenibile in Alto Adige: CO₂, ciclo di vita e futuro',
    kategorie: 'Nachhaltigkeit',
    datum: '2025-11-28',
    lesezeit: '6 min',
    vorschau: 'Holz ist das einzige Baumaterial, das aktiv CO₂ speichert. Warum nachhaltiger Holzbau in Südtirol mehr als ein Trend ist.',
    vorschau_it: 'Il legno è l\'unico materiale da costruzione che immagazzina attivamente CO₂. Perché la costruzione in legno sostenibile in Alto Adige è più di una tendenza.',
    bild: 'https://images.unsplash.com/photo-1448375240586-882707db888b?w=800&q=80',
    inhalt: `
## Holz als Klimaschutzmaßnahme

Während Beton und Stahl zum weltweiten CO₂-Problem beitragen, ist Holz ein Teil der Lösung. Ein Kubikmeter Fichtenholz bindet ca. 0,8 Tonnen CO₂ – für die Lebensdauer des Gebäudes.

Ein Holzhaus ist kein neutrales Objekt. Es ist eine CO₂-Senke.

## Südtirols Wälder als Ressource

Südtirol ist zu über 40% bewaldet. Die Forstwirtschaft ist seit Jahrhunderten Teil der Kulturlandschaft. Nachhaltig bewirtschaftete Wälder wachsen schneller nach, als geerntet wird – das ist die Grundlage aller Zertifizierungssysteme wie FSC und PEFC.

Holz aus Südtiroler Wäldern hat kurze Transportwege – das verbessert die Klimabilanz zusätzlich.

## Der Vergleich zur Konventionalität

- Herstellung von 1 Tonne Zement: ~0,9 Tonnen CO₂
- Herstellung von 1 Tonne Stahl: ~1,8 Tonnen CO₂
- Herstellung von 1 m³ Holz (inkl. Transport): ~0,02 Tonnen CO₂ – gleichzeitig bindet es 0,8 Tonnen

Die Rechnung ist eindeutig.

## Ende des Lebenszyklus

Was passiert mit einem Holzhaus nach 80 Jahren? Das Holz kann thermisch verwertet werden (Energierückgewinnung) oder zu neuen Holzprodukten verarbeitet werden. Das Kreislaufprinzip funktioniert beim Holz besser als bei fast jedem anderen Baumaterial.

## Klimahaus und Holzbau – ein natürliches Paar

Das Südtiroler KlimaHaus-Programm und Holzbau ergänzen sich perfekt. Geringe Wärmeleitfähigkeit, minimale Wärmebrücken und eine schlanke Konstruktion machen Klimahaus A und A+ im Holzbau zur Normalität – nicht zur Ausnahme.

## Unsere Haltung

Nachhaltigkeit ist für uns kein Marketing-Argument. Es ist die logische Konsequenz des Bauens mit dem richtigen Material. Wir verwenden wo immer möglich regionales Holz aus zertifizierter Forstwirtschaft und dokumentieren das transparent.
    `
  }
];

export const getArtikelBySlug = (slug) => artikel.find(a => a.slug === slug);
export const kategorien = ['Alle', 'Aufstockung', 'Dachstuhl', 'Holzfassaden', 'Sanierung', 'Hotelbau', 'Planung', 'Holzhaus', 'Terrassen', 'Nachhaltigkeit'];
